import {rwbApi} from '../../../shared/apis/api';

function putMediaUpload(url, data) {
  return fetch(url, {
    method: 'PUT',
    body: data,
  }).then((result) => {
    return result;
  });
}

// this file handles uploading and setting images
// this primarily is used to ensure any photos that should be sent to azure do, and we use their url
const imageHandler = async (file, type) => {
  const validTypes = ['cover', 'profile', 'event', 'post'];
  if (!validTypes.includes(type))
    throw new Error(
      "imageHandler expects a type of 'cover', 'profile', 'event', or 'post'",
    );
  const reader = new FileReader();
  if (file) {
    return new Promise((resolve, reject) => {
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const data = {
          media_filename: file.name.replace(/ /g, ''), //avoid spaces in the name used for the url
          media_intent: 'cover',
        };
        let imgBlob = new Blob([reader.result], {type: file.type});
        return rwbApi.getMediaUploadURL(JSON.stringify(data)).then((result) => {
          const mediaURL = result.media_upload_url;
          return putMediaUpload(mediaURL, imgBlob).then((result) => {
            const imageURL = mediaURL.split('?')[0];
            resolve(imageURL);
          });
        });
      };
    });
  }
};

export default imageHandler;
